// O que a tela do Garçom mostra: pratos de MESA que saíram da cozinha.
//
// "Saiu" tem dois jeitos de acontecer e os dois contam: a cozinha marcou o
// produto sozinho (pronto_at no item) ou subiu a comanda inteira pelo botão
// "Marcar Pronto" (status do pedido = pronto, e nenhum item ganha marca
// própria). Olhar só a marca do item esconderia do garçom toda comanda que a
// cozinha fechou de uma vez.

import { chaveDaComanda } from "./envios";
import { canceladosRecentes, ehDeMesa, itensCancelados, itensVivos } from "./kds";

export function saiuDaCozinha(item, pedido) {
  return !!item.pronto_at || pedido.status === "pronto";
}

/** Há quanto tempo o prato espera o garçom: o primeiro item que saiu, ou a
 *  hora em que a comanda inteira subiu. */
function esperandoDesde(itens, pedido) {
  const marcas = itens.map((i) => i.pronto_at).filter(Boolean).sort();
  return marcas[0] || pedido.ts_pronto || pedido.ts_producao || pedido.created_at;
}

export function montarGarcom(pedidos, agora = Date.now()) {
  const paraLevar = [];
  const entregues = [];
  for (const p of pedidos || []) {
    if (!ehDeMesa(p)) continue;
    const vivos = itensVivos(p);
    const esperando = vivos.filter((i) => saiuDaCozinha(i, p) && !i.entregue_at);
    // Prato que já saiu da cozinha e foi cancelado na mesa: riscado, "não levar"
    const cancelados = itensCancelados(p).filter((i) => saiuDaCozinha(i, p) && !i.entregue_at);
    if (!esperando.length && canceladosRecentes(cancelados, agora).length) {
      paraLevar.push({
        ...p, _itens: canceladosRecentes(cancelados, agora), _soCancelados: true, _naCozinha: 0,
        _desde: esperandoDesde(cancelados, p), _cardId: `${chaveDaComanda(p)}:levar`,
      });
    }
    const jaForam = vivos.filter((i) => i.entregue_at);
    const naCozinha = vivos.filter((i) => !saiuDaCozinha(i, p)).length;
    if (esperando.length) {
      paraLevar.push({
        ...p, _itens: [...esperando, ...cancelados], _naCozinha: naCozinha,
        _desde: esperandoDesde(esperando, p), _cardId: `${chaveDaComanda(p)}:levar`,
      });
    }
    if (jaForam.length) {
      const ultima = jaForam.map((i) => i.entregue_at).sort().pop();
      entregues.push({ ...p, _itens: jaForam, _ultimaEntrega: ultima, _cardId: `${chaveDaComanda(p)}:entregue` });
    }
  }
  // Quem espera há mais tempo primeiro; entregues, o mais recente em cima
  // (é onde o garçom procura quando precisa desfazer).
  paraLevar.sort((a, b) => String(a._desde).localeCompare(String(b._desde)));
  entregues.sort((a, b) => String(b._ultimaEntrega).localeCompare(String(a._ultimaEntrega)));
  return { paraLevar, entregues };
}

/** Pratos esperando o garçom (cancelado não conta). Quando sobe, toca o som. */
export function pratosParaLevar(paraLevar) {
  return (paraLevar || []).reduce((n, c) => n + c._itens.filter((i) => !i._cancelado).length, 0);
}
